/**
 * TagRegisterContainer
 * --
 */
import { useEffect, useState } from 'react';
import { useGetTags } from 'hooks/TagHooks';
import TagRegisterPresenter from './TagRegisterPresenter';

const TagRegisterContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */  
  const [ tagList, setTagList ] = useState([]);
  /* ===== VARIABLE ===== */
  const response = useGetTags();
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  useEffect(() => {
    if (response && response.data) {
      const { data } = response.data;
      setTagList(data);
    }
  }, [response])
  /* ===== RENDER ===== */
  return (
    <>
      <TagRegisterPresenter tagList={tagList} />
    </>
  );
};

export default TagRegisterContainer;
